import { LoginViewModel } from "./Auth/LoginViewModel";

export class ViewModelLocator {
    public static LoginVM: LoginViewModel | null = null;
}